import logoWhite from "../../assets/images/logo_white.svg";
import Fetcher from "../../clients/Fetcher";
import { queryClient } from "../../clients/queries";
import { useUser } from "../../context/UserContext";
import { Button, MagicToast } from "../DesignSystem";
import { useState } from "react";

const PanelActions = () => {
    const actions = [
        {
            label: "Test",
            action: async () => {},
        },
        {
            label: "Test",
            action: async () => {},
        },
        {
            label: "Test",
            action: async () => {},
        },
    ];

    return (
        <>
            <div className="grid h-fit grid-cols-4 items-start gap-3">
                {actions.map(panelAction => {
                    return <Button text={panelAction.label} color="bronze" onClick={panelAction.action} />;
                })}
            </div>

            {/* Modals can go here, just make sure they have overlayClassName="z-[2147483647]!" so they show above everything */}
        </>
    );
};

const PurchaserDevPanel = () => {
    const { user } = useUser();

    return (
        <div className="no-scrollbar flex h-full w-full flex-col gap-4 overflow-y-auto bg-black p-4 text-white">
            <div className="h-10 max-h-10 min-h-10 w-40 shrink-0 overflow-hidden">
                <img alt="Purchaser Logo" src={logoWhite} className="block h-full w-full object-contain object-left" />
            </div>

            <div className="max-h-fit">
                <div className="pb-2 text-xl font-bold">Actions</div>
                <PanelActions />
            </div>

            <div className="mt-4 grid grid-cols-2 items-start gap-4">
                <div className="min-w-0 pb-4">
                    <div className="pb-2 text-xl font-bold">Current User</div>
                    <pre className="w-full max-w-full rounded-xl border border-slate-200 p-3 wrap-break-word whitespace-pre-wrap">
                        {JSON.stringify(user, null, 2)}
                    </pre>
                </div>
                <div className="min-w-0">
                    <div className="pb-2 text-xl font-bold">Current Token</div>
                    <pre className="w-full max-w-full rounded-xl border border-slate-200 p-3 break-all whitespace-pre-wrap">
                        {localStorage.getItem("token")}
                    </pre>
                </div>
            </div>
        </div>
    );
};

export default PurchaserDevPanel;
